import { TimerSample } from "../Timer"
import { Metrics } from "../Metrics"
import { TransportResponse } from "../../transport/Transport"

export type ApiOperation =
  | "get.workspace"
  | "post.events"
  | "get.cohorts"
  | "get.user-targets"
  | "get.iam-html"
  | "evaluate.workspace"
  | "evaluate.entities"

export class ApiCallMetrics {
  static async record(operation: ApiOperation, call: () => Promise<TransportResponse>): Promise<TransportResponse> {
    const sample = TimerSample.start()
    try {
      const response = await call()
      ApiCallMetrics.stop(operation, sample, response)
      return response
    } catch (e) {
      ApiCallMetrics.stop(operation, sample, null)
      throw e
    }
  }

  private static stop(operation: ApiOperation, sample: TimerSample, response: TransportResponse | null) {
    const timer = Metrics.timer("api.call", {
      operation,
      success: ApiCallMetrics.success(response)
    })
    sample.stop(timer)
  }

  private static success(response: TransportResponse | null): string {
    if (response === null) {
      return "false"
    }
    return String(response.isSuccessful() || response.isNotModified())
  }
}
